import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

const rootElement = document.getElementById('root');
const loader = document.getElementById('initial-loader');

const PREBRAND_DURATION = 350;
const BRAND_REVEAL_DURATION = 500;
const BRAND_COMPLETE_DELAY = 450;
const BRAND_DWELL_DURATION = 800;

if (rootElement) {
  const root = createRoot(rootElement);
  let loaderTransitionStarted = false;
  let fallbackTimer = 0;

  const startLoaderTransition = () => {
    window.clearTimeout(fallbackTimer);
    if (loaderTransitionStarted) return;
    loaderTransitionStarted = true;
    window.removeEventListener('crevvi-app-mounted', startLoaderTransition);
    window.removeEventListener('crevvi-loader-ready', startLoaderTransition);

    if (!loader) {
      rootElement.classList.add('root--visible');
      return;
    }

    loader.classList.add('initial-loader--prebrand');
    window.setTimeout(() => {
      loader.classList.add('initial-loader--brand');
      window.setTimeout(() => {
        loader.classList.add('initial-loader--brand-complete');
      }, BRAND_COMPLETE_DELAY);
      window.setTimeout(() => {
        rootElement.classList.add('root--visible');
        loader.classList.add('opacity-0', 'transition-opacity', 'duration-300');
        loader.classList.add('initial-loader--fade');
        window.setTimeout(() => loader.remove(), 300);
      }, BRAND_REVEAL_DURATION + BRAND_DWELL_DURATION);
    }, PREBRAND_DURATION);
  };

  fallbackTimer = window.setTimeout(startLoaderTransition, 6000);
  window.addEventListener('crevvi-app-mounted', startLoaderTransition, { once: true });
  window.addEventListener('crevvi-loader-ready', startLoaderTransition, { once: true });

  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}
